import { createSlice } from '@reduxjs/toolkit';
import { mockTags } from '../../data/mockData';
import { Tag } from '../../types';

interface TagsState {
  items: Tag[];
}

const initialState: TagsState = {
  items: mockTags,
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {},
});

export default tagsSlice.reducer;
